import React from "react";

import LoginFormContainerNative from "../components/loginForm/container/LoginFormNativeContainer";

const LandingLoginContainer = () => {
    return (
        <div>
            <LoginFormContainerNative></LoginFormContainerNative>
        </div>
    );
};

export default LandingLoginContainer;
